function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
/**
 * Shared helper for fetching popular search terms from the Algolia
 * Query Suggestions index.
 *
 * Used by:
 *  - The search drawer empty state (`algolia-predictive-search.js`)
 *  - The search results page empty state (`algolia-listing.js`)
 */

function suggestionTextFromHit(hit) {
  var _hit$query, _hit$objectID;
  var q = String((_hit$query = hit.query) !== null && _hit$query !== void 0 ? _hit$query : '').trim();
  if (q) return q;
  return String((_hit$objectID = hit.objectID) !== null && _hit$objectID !== void 0 ? _hit$objectID : '').trim();
}
function parsePopularTermsFromResponse(res) {
  var _res$results$;
  var hits = ((_res$results$ = res.results[0]) === null || _res$results$ === void 0 ? void 0 : _res$results$.hits) || [];
  var out = [];
  var seen = new Set();
  for (var h of hits) {
    var t = suggestionTextFromHit(h);
    if (!t || seen.has(t.toLowerCase())) continue;
    seen.add(t.toLowerCase());
    out.push(t);
  }
  return out;
}

/**
 * Fetch up to `limit` popular search terms from the configured Query
 * Suggestions index. Returns an empty array when the index is not
 * configured or the request fails.
 *
 * @param {import('algoliasearch/lite').LiteClient} client
 * @param {{ querySuggestionsIndexName?: string }} cfg
 * @param {number} [limit=10]
 * @returns {Promise<string[]>}
 */
export function fetchPopularTerms(_x, _x2) {
  return _fetchPopularTerms.apply(this, arguments);
}
function _fetchPopularTerms() {
  _fetchPopularTerms = _asyncToGenerator(function* (client, cfg) {
    var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10;
    var indexName = String((cfg === null || cfg === void 0 ? void 0 : cfg.querySuggestionsIndexName) || '').trim();
    if (!indexName) return [];
    try {
      var res = yield client.search({
        requests: [{
          indexName,
          query: '',
          hitsPerPage: limit
        }]
      });
      return parsePopularTermsFromResponse(res).slice(0, limit);
    } catch (e) {
      console.warn('[Algolia] Query suggestions failed', e);
      return [];
    }
  });
  return _fetchPopularTerms.apply(this, arguments);
}